import React, { useState, useEffect } from 'react';
import styles from './home.module.scss';
import YouTube from 'react-youtube';
import classnames from 'classnames';
import Scroll from 'react-scroll';
import history from '../../components/utils/routes/history'
import qs from 'qs'
import { withRouter } from 'react-router-dom'
import 'animate.css'

// Components
import AuthBlock from '../../components/Authentication/authBlock';
import DescriptionOption from './../../components/descriptionOption';
import SecondaryButton from '../../components/Buttons/secondaryButton';
import Footer from '../../components/Footer/footer';

// Assets
import HHLogo from './../../img/homyhub_logo_horizontal_white.svg';
import PlantShopImg from './../../img/app_plant_shop.jpg';
import ArrowIcon from './../../img/icons/arrow.svg';
import GarajeImage1 from './../../img/garaje1.png';
import GarajeImage2 from './../../img/garaje2.png';
import GarajeImage3 from './../../img/garaje3.png';
import GarajeImage4 from './../../img/garaje4.png';

// Icons
import EarthIcon from '../../img/icons/earth.svg'
import LockPersonIcon from '../../img/icons/lock_person.svg'
import EyeIcon from '../../img/icons/eye.svg'
import ProximityIcon from '../../img/icons/proximity_thin.svg'

import { strings } from '../../components/utils/translations';
import API from '../../components/utils/API'


const Home = (props) =>
{
    const [activeFeature, setActiveFeature] = useState(1);
    const [featuresActiveBarTop, setFeaturesActiveBarTop] = useState(0);
    const [showLogin, setShowLogin] = useState(false);
    const [videoIsPlaying, setVideoIsPlaying] = useState(false);

    function handleScroll()
    {
        let featuresTop = document.querySelectorAll('.characteristicsBlock .features')[0]?.offsetTop + document.querySelectorAll('.characteristicsBlock .features .featuresImages')[0]?.offsetTop;
        let imagesHeight = document.querySelectorAll('.characteristicsBlock .featuresImages')[0]?.offsetHeight;
        let trailHeight = document.querySelectorAll('.characteristicsBlock .activeOptionTrail')[0]?.offsetHeight;

        let percentageScrolled = parseFloat((window.pageYOffset - featuresTop) / imagesHeight);//.toFixed(3);

        if (percentageScrolled >= 0 && percentageScrolled <= 0.75)
        {
            setFeaturesActiveBarTop(trailHeight * percentageScrolled);
            setActiveFeature(Math.round(percentageScrolled*3/0.75)+1);
        }
        
        // console.log(percentageScrolled * 100);
    }
    function scrollToFeature(featureNum)
    {
        let image = document.querySelectorAll('.characteristicsBlock .featuresImages .imageContainer')[featureNum-1];
        Scroll.animateScroll.scrollTo(image.offsetParent.offsetTop + image.offsetTop,
        {
            duration: 400,
            delay: 0,
            smooth: true
        });
    }

    useEffect(() =>
    {
        let hasActiveSession = API.getInstance().hasActiveSession()
        let searchParams = qs.parse(props.location.search, { ignoreQueryPrefix: true })
        let accessToken = searchParams?.access_token
        let userId = searchParams?.user_id
        
        if (accessToken && userId)
        {
            API.getInstance().setExternalAccessToken(accessToken, userId)
            
            delete searchParams.access_token
            delete searchParams.user_id
            history.push('/extra-virtual-remotes?' + qs.stringify(searchParams))
        }
        else if (hasActiveSession)
            history.push('/garages')
        
        
        function watchScroll()
        {
            window.addEventListener("scroll", handleScroll);
        }
        
        watchScroll();
        
    
        return () =>
        {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return (
        <div id={styles.homeScreen}>
          <div className={styles.mainBlock}>
            <div className={classnames('responsive-container', styles['responsive-container'])}>
                <div className={styles.column}>
                  <div className={styles.navbar}>
                    <div className={styles.topLogoContainer}>
                        <img
                          alt="HOMYHUB Logo"
                          src={HHLogo}
                        />
                    </div>
                    <div className={styles.navBarElements}>
                      <p className={styles.navBarText} onClick={() => setShowLogin(true)}>{ strings('login') }</p>
                    </div>
                  </div>
                  <div className={classnames(styles.contentContainer, "animate__animated animate__fadeInLeft animate__fast")}>
                    <h1>{ strings('homeTitle') }</h1>
                    <p>{ strings('homeSubtitle') }</p>
                      <SecondaryButton
                        text={strings('login')}
                        onClick={() => setShowLogin(true)}
                        />
                  </div>
                  <img
                    className={classnames(styles.mainImgMobile, "animate__animated animate__slideInUp animate__delay-1s")}
                    alt="HOMYHUB App Stores"
                    src={PlantShopImg}
                  />
                </div>
                <div className={classnames(styles.column, { [styles.visible]: showLogin })}>
                    <AuthBlock showMobile={showLogin} onClickClose={() => setShowLogin(false)} />
                </div>
            </div>
          </div>
          <div className={styles.welcomeBlock}>
            <div className={classnames('responsive-container', styles['responsive-container'])}>
                <div className={styles.column}>
                    <img
                      className={classnames(styles.mainImg, 'animate__animated animate__slideInUp animate__slow animate__delay-1s')}
                      alt="HOMYHUB App Stores"
                      src={PlantShopImg}
                    />
                </div>
                <div>
                    <div className={styles.containerWidth}>
                      <h3 className={styles.title}>{ strings('homeWelcomeTitle1') }</h3>
                      <p className={styles.subtitle}>{ strings('homeWelcomeSubtitle1') }</p>
                        <img
                          className={styles.icon}
                          alt="Arrow icon"
                          src={ArrowIcon}
                        />
                    </div>
                </div>
            </div>
          </div>
          <div className={classnames('characteristicsBlock', styles.characteristicsBlock)}>
            <div className={classnames('responsive-container', styles['responsive-container'], styles.videoBlock)}>
                <div className={classnames('features', styles.features)}>
                    <div className={styles.featuresTexts}>
                        <div className={styles.featuresTextsContainer}>
                            <DescriptionOption
                                styles={styles}
                                icon={EarthIcon}
                                title={ strings('homeCharacteristicsTitle1') }
                                description={ strings('homeCharacteristicsDescription1') }
                                active={activeFeature === 1}
                                src={GarajeImage1}
                                alt="HOMYHUB Control Absoluto"
                                onClick={() => scrollToFeature(1)}
                            />

                            <DescriptionOption
                                styles={styles}
                                icon={LockPersonIcon}
                                title={ strings('homeCharacteristicsTitle2') }
                                description={ strings('homeCharacteristicsDescription2') }
                                active={activeFeature === 2}
                                src={GarajeImage2}
                                alt="HOMYHUB Gestiona el acceso"
                                onClick={() => scrollToFeature(2)}
                            />

                            <DescriptionOption
                                styles={styles}
                                icon={EyeIcon}
                                title={ strings('homeCharacteristicsTitle3') }
                                description={ strings('homeCharacteristicsDescription3') }
                                active={activeFeature === 3}
                                src={GarajeImage3}
                                alt="HOMYHUB Monitoriza la actividad"
                                onClick={() => scrollToFeature(3)}
                            />

                            <DescriptionOption
                                styles={styles}
                                icon={ProximityIcon}
                                title={ strings('homeCharacteristicsTitle4') }
                                description={ strings('homeCharacteristicsDescription4') }
                                active={activeFeature === 4}
                                src={GarajeImage4}
                                alt="HOMYHUB Apertura por proximidad"
                                onClick={() => scrollToFeature(4)}
                            />

                            <div className={classnames('activeOptionTrail', styles.activeOptionTrail)}>
                                <div className={styles.activeOptionBarContainer} style={{ transform: `translateY(${featuresActiveBarTop}px)` }}>
                                    <div className={styles.activeOptionBar}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classnames('featuresImages', styles.featuresImages)}>
                        <div className={classnames('imageContainer', styles.imageContainer)}>
                            <img
                                className={styles.charImg}
                                alt="HOMYHUB Garaje 1"
                                src={GarajeImage1}
                            />
                        </div>
                        <div className={classnames('imageContainer', styles.imageContainer)}>
                            <img
                                className={styles.charImg}
                                alt="HOMYHUB Garaje 2"
                                src={GarajeImage2}
                            />
                        </div>
                        <div className={classnames('imageContainer', styles.imageContainer)}>
                            <img
                                className={styles.charImg}
                                alt="HOMYHUB Garaje 3"
                                src={GarajeImage3}
                            />
                        </div>
                        <div className={classnames('imageContainer', styles.imageContainer)}>
                            <img
                                className={styles.charImg}
                                alt="HOMYHUB Garaje 4"
                                src={GarajeImage4}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.videoContainer}>
                    <div className={styles.video}>
                        <div className={classnames(styles.overlay, { [styles.hidden]: videoIsPlaying })}>
                            <div className={styles.playButton}>
                                <div className={styles.icon}></div>
                                <div className={styles.text}>{ strings('watchVideo') }</div>
                            </div>
                        </div>
                        
                        <YouTube
                            videoId={'6Sgxqq3Ocmk'}
                            className={styles.videoIframe}
                            containerClassName={styles.videoIframeContainer}
                            opts={{}}
                            onPlay={() => setVideoIsPlaying(true)}
                        />
                    </div>
                </div>
            </div>
          </div>

          <Footer />
        </div>
    );
}

export default withRouter(Home);
